<template>
    <div class="position-relative p-3">
        <!-- Begin Page Content -->
        <div class="Analyze-section">
            <loader v-if="pageLoader"></loader>
        	<div class="backTop d-flex justify-content-end mb-3">
            	<a href="#" class="themecolor d-flex align-items-center medium whiteButton" @click.prevent="redirection('TestReport')">
                    <span class="plusCircle mb-0 bg-white mr-2"><feather class="mr-1" type="chevron-left"></feather></span> Back</a>
            </div>
            <div class="row mb-4">
                <div class="col-lg-12">
                    <div class="bg-white border-radius-5 p-3">
                        <div class="card border-0 bg-white border-radius-5 h-100" v-if="!pageLoader && Object.keys(testReportDetail).length > 0">
                            <div class="card-bodytext-center text-center" v-if="testReportDetail.hasOwnProperty('dataAddedByadmin') && Object.keys(testReportDetail.dataAddedByadmin).length > 0">
                                <div class="table-responsive ">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Name of Test</th>
                                                <th v-if="testReportDetail.Source =='Thyrocare' || testReportDetail.Source =='Nueclear'">TECHNOLOGY</th>
                                                <th>Lab Range</th>
                                                <th >Your Levels</th>
                                                <th>Comment</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="testReportDetail.Source == 'Lal path labs' || testReportDetail.Source =='Srl' || testReportDetail.Source =='Healthians' || testReportDetail.Source =='Gurmeen' ">
                                            <tr v-for="(data,key,index) in testReportDetail.dataAddedByadmin">
                                                <td class="pl-4 position-relative" >
                                                    <p class="d-flex justify-content-start align-items-start mb-0">{{key}} </p>
                                                </td>
                                                <td >{{data.range}}</td>
                                                <td >{{data.value}} {{data.unit}}</td>
                                                <td >{{(data.comment)?data.comment : '-'}}</td>
                                            </tr>
                                        </tbody>
                                        <tbody v-else-if="testReportDetail.Source =='Thyrocare' || testReportDetail.Source =='Nueclear'">
                                            <tr v-for="(data,key,index) in testReportDetail.dataAddedByadmin">
                                                <td class="pl-4 position-relative" >
                                                    <p class="d-flex justify-content-start align-items-start mb-0">{{key}} </p>
                                                </td>
                                                <td >{{data.technology}}</td>
                                                <td >{{data.range}}</td>
                                                <td >{{data.value}} {{data.unit}}</td>
                                                <td >{{(data.comment)?data.comment : '-'}}</td>
                                            </tr>
                                        </tbody>
                                        <tbody v-else-if="Object.keys(testReportDetail.dataAddedByadmin).length == 0">
                                            <no-record :type="'table'" :colspan="'6'"></no-record>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="card-bodytext-center text-center" v-else-if="testReportDetail.hasOwnProperty('cleanData') && Object.keys(testReportDetail.cleanData).length > 0">
                                <div class="table-responsive ">
    	                            <table class="table">
    	                                <thead>
    	                                    <tr>
    	                                        <th>Name of Test</th>
    	                                        <th v-if="testReportDetail.Source =='Thyrocare' || testReportDetail.Source =='Nueclear'">TECHNOLOGY</th>
    	                                        <th>Lab Range</th>
                                                <th>Your Levels</th>
                                                <th>Comment</th>
    	                                    </tr>
    	                                </thead>
    	                                <tbody v-if="testReportDetail.Source == 'Lal path labs' || testReportDetail.Source =='Srl' || testReportDetail.Source =='Healthians' || testReportDetail.Source =='Gurmeen' ">
    	                                    <tr v-for="(value,key,index) in reportdata">
    	                                        <td class="pl-4 position-relative" >
                                                    <p class="d-flex justify-content-start align-items-start mb-0">{{key}} </p>
                                                </td>
                                                <td>{{value.range}}</td>
                                                <td>{{value.value}} {{value.unit}}</td>
                                                <td>{{(value.comment)?value.comment : '-'}}</td>
    	                                       
    	                                    </tr>
    	                                </tbody>
    	                                <tbody v-else-if="testReportDetail.Source =='Thyrocare' || testReportDetail.Source =='Nueclear'">
    	                                	<tr v-for="(value,key,index) in reportdata">
    	                                        <td class="pl-4 position-relative" >
                                                    <p class="d-flex justify-content-start align-items-start mb-0">{{key}} </p>
                                                </td>
                                                <td >{{value.technology}}</td>
                                                <td>{{value.range}}</td>
                                                <td>{{value.value}} {{value.unit}}</td>
                                                <td>{{(value.comment)?value.comment : '-'}}</td>
    	                                    </tr>
    	                                </tbody>
    	                                 <tbody v-else-if="Object.keys(testReportDetail.dataAddedByadmin).length == 0">
                                            <table-no-record :type="'table'" :colspan="'6'"></table-no-record>
                                        </tbody>
    	                            </table>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="!pageLoader && Object.keys(testReportDetail).length == 0">
                        	<no-record  :type="'complete'"></no-record>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
	 import { Const } from "../../../plugins/Gini/provider/candle-history/lib/const.cls.ts"
	export default {
        name: 'Analyze-report',
        data () {
            return {
                pageLoader : false,
                submitted: false,
                addbiomarker : false,
                dynamicVar :{},
                commentdata :{},
                reportdata :{},
            }
        }, 
        methods:{
        	listing(){
        		let inputJson = {
                    'globalParams' :{
                        id: this.$route.query.id
                    },'localParams' :{'parameter' : this}
                }
                this._runGetPatientTestReportDetail(inputJson)
        	},
        },
        created(){
           this.pageName('Analyze Your Report')
           this.listing()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/test_report/analyze-report.vue